import { LABELLING_TYPE } from '../../../common/constant/constant';
import { DEFAULT_BRUSH_TOOL_SETTINGS, GRID_MODE, TOOL } from '../constants';
import { PROPAGATION_METHOD } from '../reducers/actions/constants';
import { type LabelStateT, EDITOR_MODE_TYPE } from '../types';
export const DEFAULT_STORE: LabelStateT = {
  copiedAnnotationId: null,
  dataUrl: null,
  mediaFileReference: null,
  frames: [],
  annotationReviewStore: {},
  currentFrame: 0,
  hoveredFrame: null,
  selectedAnnotationLabel: null,
  selectedTool: TOOL.POINTER,
  brushToolSettings: DEFAULT_BRUSH_TOOL_SETTINGS,
  selectedAnnotationIds: [],
  multiSelectEnabled: false,
  focusedAnnotationIdx: null,
  gridMode: GRID_MODE.NONE,
  snapEnabled: false,
  showAnnotationDetails: false,
  showMLAnnotations: false,
  metaData: {
    height: 0,
    width: 0,
    rotation: 0
  },
  validations: {
    invalidSource: false,
    labelValidation: {
      isRequiredLabelAnnotated: true,
      reasons: []
    }
  },
  annotationLabels: [],
  superpixel: {
    superpixelSegmentsNumbers: [500, 1000]
  },
  editorMode: EDITOR_MODE_TYPE.LABELING,
  relationshipMode: undefined,
  isLoading: false,
  annotationUnderUserReview: {},
  fileType: LABELLING_TYPE.IMAGE,
  annotationPropagationMethod: PROPAGATION_METHOD.TRACKING
};